export default {
  "content": "<path d=\"M18.5 4.5v12.086l2.793-2.793 1.414 1.414-4.5 4.5a1 1 0 01-1.34.066l-.074-.066-4.5-4.5 1.414-1.414 2.793 2.793V4.5h2zM6.5 4a1 1 0 01.707.293l4.5 4.5-1.414 1.414L7.5 7.414V19.5h-2V7.414l-2.793 2.793-1.414-1.414 4.5-4.5.073-.066A1 1 0 016.5 4z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};